// extracted by css-extract-rspack-plugin
export default {"link":"link-F24FZ7","underlineNone":"underlineNone-hUyoCy","underlineHover":"underlineHover-kq2G8J","underlineAlways":"underlineAlways-MaVaDz"};